import { Warehouses } from '../../../reducers/warehouses/types';

export const UPDATE_WAREHOUSES = 'warehouses/UPDATE_WAREHOUSES';

export interface UpdateWarehousesAction {
    type: typeof UPDATE_WAREHOUSES;
    payload: Warehouses;
}

export type WarehouseActions = UpdateWarehousesAction;
